"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class EuroCents {
    constructor(cents) {
        // SMELL not good, we should have more clearly defined error boundary
        if (!Number.isInteger(cents)) {
            throw new Error(`cents must be integer, was ${cents}`);
        }
        this.cents = cents;
    }
    plus(x) {
        return new EuroCents(this.cents + x.cents);
    }
    minus(x) {
        return new EuroCents(this.cents - x.cents);
    }
    euros() {
        return this.cents / 100;
    }
    static zero() {
        return new EuroCents(0);
    }
}
EuroCents.fromValue = (cents) => new EuroCents(cents);
exports.EuroCents = EuroCents;
